import { Tag } from 'antd';
import React from 'react';

const labels = {
  waitingForAuthorization: 'Aguardando autorização do paciente',
  pending: 'Aguardando profissional',
  accepted: 'Aceito',
  rejected: 'Convite rejeitado',
  refuse: 'Não autorizado pelo paciente'
};

const colors = {
  waitingForAuthorization: 'orange',
  pending: 'grey',
  accepted: 'green',
  rejected: 'red',
  refuse: 'red'
};

const TreatmentPartnerStatus = ({ status }) => {
  return <Tag color={colors[status]}>{labels[status]}</Tag>;
};

export default TreatmentPartnerStatus;
